import sogardAvatar from '~/features/chatbot/assets/sogard-avatar.png';

export const CHATBOT_CONFIG = {
    headerTitle: 'MDM OTA Assistant',
    name: 'Sogard',
    avatar: sogardAvatar,
};
